/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for FormationResource controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_FORMATIONAPI, CLIENT_CONTEXT_TOKEN_FORMATIONAPI } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, PagedModelFormationListDTO, FormationViewDTO, ParametrageDTO, LoadFormationRespDto, FormationValideListDTO, FormationListDTO, FormationListSimpleDTO, GroupFormationDTO } from "../models";

@Injectable({ providedIn: "root" })
export class FormationResourceService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_FORMATIONAPI);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_FORMATIONAPI;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'formationApi');
    }

    getAllFormationsByPage(archive?: boolean, page?: number, size?: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<PagedModelFormationListDTO>;
    getAllFormationsByPage(archive?: boolean, page?: number, size?: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<PagedModelFormationListDTO>>;
    getAllFormationsByPage(archive?: boolean, page?: number, size?: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<PagedModelFormationListDTO>>;
    getAllFormationsByPage(archive?: boolean, page?: number, size?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/`;

        let params = new HttpParams();
        if (archive != null) {
            params = HttpParamsBuilder.addToHttpParams(params, archive, 'archive');
        }
        if (page != null) {
            params = HttpParamsBuilder.addToHttpParams(params, page, 'page');
        }
        if (size != null) {
            params = HttpParamsBuilder.addToHttpParams(params, size, 'size');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    addFormation(info: FormationViewDTO, file?: Blob, observe?: 'body', options?: RequestOptions<'json'>): Observable<FormationViewDTO>;
    addFormation(info: FormationViewDTO, file?: Blob, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<FormationViewDTO>>;
    addFormation(info: FormationViewDTO, file?: Blob, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<FormationViewDTO>>;
    addFormation(info: FormationViewDTO, file?: Blob, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }
        // Remove Content-Type for multipart (browser will set it with boundary)
        headers = headers.delete('Content-Type');

        const formData = new FormData();
        if (file !== undefined) {
            formData.append('file', file);
        }
        if (info !== undefined) {
            formData.append('info', String(info));
        }

        return this.httpClient.request('post', url, {
            body: formData,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    updateFormation(info: FormationViewDTO, file?: Blob, observe?: 'body', options?: RequestOptions<'json'>): Observable<FormationViewDTO>;
    updateFormation(info: FormationViewDTO, file?: Blob, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<FormationViewDTO>>;
    updateFormation(info: FormationViewDTO, file?: Blob, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<FormationViewDTO>>;
    updateFormation(info: FormationViewDTO, file?: Blob, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }
        // Remove Content-Type for multipart (browser will set it with boundary)
        headers = headers.delete('Content-Type');

        const formData = new FormData();
        if (file !== undefined) {
            formData.append('file', file);
        }
        if (info !== undefined) {
            formData.append('info', String(info));
        }

        return this.httpClient.request('put', url, {
            body: formData,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    publish(observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    publish(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    publish(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    publish(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/publish`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getParametrageCampusen(observe?: 'body', options?: RequestOptions<'json'>): Observable<ParametrageDTO>;
    getParametrageCampusen(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<ParametrageDTO>>;
    getParametrageCampusen(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<ParametrageDTO>>;
    getParametrageCampusen(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/parametrage-campusen`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    validerFormation(ids: string, observe?: 'body', options?: RequestOptions<'text'>): Observable<number>;
    validerFormation(ids: string, observe?: 'response', options?: RequestOptions<'text'>): Observable<HttpResponse<number>>;
    validerFormation(ids: string, observe?: 'events', options?: RequestOptions<'text'>): Observable<HttpEvent<number>>;
    validerFormation(ids: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/validerFormation`;

        let params = new HttpParams();
        if (ids != null) {
            params = HttpParamsBuilder.addToHttpParams(params, ids, 'ids');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'text',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    validerAccrediterFormation(ids: string, accreditation?: string, date?: string, duree?: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<FormationViewDTO>;
    validerAccrediterFormation(ids: string, accreditation?: string, date?: string, duree?: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<FormationViewDTO>>;
    validerAccrediterFormation(ids: string, accreditation?: string, date?: string, duree?: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<FormationViewDTO>>;
    validerAccrediterFormation(ids: string, accreditation?: string, date?: string, duree?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/validerAccrediterFormation`;

        let params = new HttpParams();
        if (ids != null) {
            params = HttpParamsBuilder.addToHttpParams(params, ids, 'ids');
        }
        if (accreditation != null) {
            params = HttpParamsBuilder.addToHttpParams(params, accreditation, 'accreditation');
        }
        if (date != null) {
            params = HttpParamsBuilder.addToHttpParams(params, date, 'date');
        }
        if (duree != null) {
            params = HttpParamsBuilder.addToHttpParams(params, duree, 'duree');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    changeValidation(idFormation: number, motif: string, status: boolean, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    changeValidation(idFormation: number, motif: string, status: boolean, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    changeValidation(idFormation: number, motif: string, status: boolean, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    changeValidation(idFormation: number, motif: string, status: boolean, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/validation/${idFormation}`;

        let params = new HttpParams();
        if (motif != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motif, 'motif');
        }
        if (status != null) {
            params = HttpParamsBuilder.addToHttpParams(params, status, 'status');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    changeStatusCampusen(idFormation: number, status: boolean, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    changeStatusCampusen(idFormation: number, status: boolean, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    changeStatusCampusen(idFormation: number, status: boolean, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    changeStatusCampusen(idFormation: number, status: boolean, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/campusen/${idFormation}`;

        let params = new HttpParams();
        if (status != null) {
            params = HttpParamsBuilder.addToHttpParams(params, status, 'status');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archiveFormation(id: number, val: boolean, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    archiveFormation(id: number, val: boolean, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    archiveFormation(id: number, val: boolean, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    archiveFormation(id: number, val: boolean, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/archive/${id}`;

        let params = new HttpParams();
        if (val != null) {
            params = HttpParamsBuilder.addToHttpParams(params, val, 'val');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    annulerAccreditationFormation(ids: string, motif: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<FormationViewDTO>;
    annulerAccreditationFormation(ids: string, motif: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<FormationViewDTO>>;
    annulerAccreditationFormation(ids: string, motif: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<FormationViewDTO>>;
    annulerAccreditationFormation(ids: string, motif: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/annulerAccreditationFormation`;

        let params = new HttpParams();
        if (ids != null) {
            params = HttpParamsBuilder.addToHttpParams(params, ids, 'ids');
        }
        if (motif != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motif, 'motif');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getFormationByType(type: string, reference: string, page?: number, size?: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<PagedModelFormationListDTO>;
    getFormationByType(type: string, reference: string, page?: number, size?: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<PagedModelFormationListDTO>>;
    getFormationByType(type: string, reference: string, page?: number, size?: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<PagedModelFormationListDTO>>;
    getFormationByType(type: string, reference: string, page?: number, size?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/type`;

        let params = new HttpParams();
        if (type != null) {
            params = HttpParamsBuilder.addToHttpParams(params, type, 'type');
        }
        if (reference != null) {
            params = HttpParamsBuilder.addToHttpParams(params, reference, 'reference');
        }
        if (page != null) {
            params = HttpParamsBuilder.addToHttpParams(params, page, 'page');
        }
        if (size != null) {
            params = HttpParamsBuilder.addToHttpParams(params, size, 'size');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getJobLoadFormation(jobId: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<LoadFormationRespDto>;
    getJobLoadFormation(jobId: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<LoadFormationRespDto>>;
    getJobLoadFormation(jobId: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<LoadFormationRespDto>>;
    getJobLoadFormation(jobId: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/rattrapage/${jobId}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getAllFormationsValides(observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<FormationValideListDTO>>;
    getAllFormationsValides(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<FormationValideListDTO>>>;
    getAllFormationsValides(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<FormationValideListDTO>>>;
    getAllFormationsValides(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-formations-valides`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getAllFormationsPublic(archive?: boolean, valideyn?: boolean, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<FormationListDTO>>;
    getAllFormationsPublic(archive?: boolean, valideyn?: boolean, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<FormationListDTO>>>;
    getAllFormationsPublic(archive?: boolean, valideyn?: boolean, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<FormationListDTO>>>;
    getAllFormationsPublic(archive?: boolean, valideyn?: boolean, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-formations-public`;

        let params = new HttpParams();
        if (archive != null) {
            params = HttpParamsBuilder.addToHttpParams(params, archive, 'archive');
        }
        if (valideyn != null) {
            params = HttpParamsBuilder.addToHttpParams(params, valideyn, 'valideyn');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getAllFormationsPrive(archive?: boolean, valideyn?: boolean, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<FormationListDTO>>;
    getAllFormationsPrive(archive?: boolean, valideyn?: boolean, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<FormationListDTO>>>;
    getAllFormationsPrive(archive?: boolean, valideyn?: boolean, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<FormationListDTO>>>;
    getAllFormationsPrive(archive?: boolean, valideyn?: boolean, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-formations-prive`;

        let params = new HttpParams();
        if (archive != null) {
            params = HttpParamsBuilder.addToHttpParams(params, archive, 'archive');
        }
        if (valideyn != null) {
            params = HttpParamsBuilder.addToHttpParams(params, valideyn, 'valideyn');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getAllFormationsIes(idIes?: number, archive?: boolean, valideyn?: boolean, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<FormationListDTO>>;
    getAllFormationsIes(idIes?: number, archive?: boolean, valideyn?: boolean, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<FormationListDTO>>>;
    getAllFormationsIes(idIes?: number, archive?: boolean, valideyn?: boolean, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<FormationListDTO>>>;
    getAllFormationsIes(idIes?: number, archive?: boolean, valideyn?: boolean, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-formations-ies`;

        let params = new HttpParams();
        if (idIes != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idIes, 'idIes');
        }
        if (archive != null) {
            params = HttpParamsBuilder.addToHttpParams(params, archive, 'archive');
        }
        if (valideyn != null) {
            params = HttpParamsBuilder.addToHttpParams(params, valideyn, 'valideyn');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getAllFormationsUserArchive(userid?: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<FormationListSimpleDTO>>;
    getAllFormationsUserArchive(userid?: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<FormationListSimpleDTO>>>;
    getAllFormationsUserArchive(userid?: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<FormationListSimpleDTO>>>;
    getAllFormationsUserArchive(userid?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-formations-etablissement-archive`;

        let params = new HttpParams();
        if (userid != null) {
            params = HttpParamsBuilder.addToHttpParams(params, userid, 'userid');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getAllFormationsAnaqValides(observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<FormationListDTO>>;
    getAllFormationsAnaqValides(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<FormationListDTO>>>;
    getAllFormationsAnaqValides(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<FormationListDTO>>>;
    getAllFormationsAnaqValides(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-formations-anaq-valides`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getAllFormationsAnaqAvalider(observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<FormationListDTO>>;
    getAllFormationsAnaqAvalider(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<FormationListDTO>>>;
    getAllFormationsAnaqAvalider(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<FormationListDTO>>>;
    getAllFormationsAnaqAvalider(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-formations-anaq-avalider`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getByGroup(group: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<GroupFormationDTO>>;
    getByGroup(group: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<GroupFormationDTO>>>;
    getByGroup(group: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<GroupFormationDTO>>>;
    getByGroup(group: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/group`;

        let params = new HttpParams();
        if (group != null) {
            params = HttpParamsBuilder.addToHttpParams(params, group, 'group');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getFiche(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<FormationListDTO>;
    getFiche(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<FormationListDTO>>;
    getFiche(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<FormationListDTO>>;
    getFiche(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/fiche`;

        let params = new HttpParams();
        if (id != null) {
            params = HttpParamsBuilder.addToHttpParams(params, id, 'id');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getFormationsCampusen(observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<FormationListDTO>>;
    getFormationsCampusen(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<FormationListDTO>>>;
    getFormationsCampusen(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<FormationListDTO>>>;
    getFormationsCampusen(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/campusen`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
